import { render, staticRenderFns } from "./batchCreate.vue?vue&type=template&id=2c4b1eb0&"
import script from "./batchCreate.vue?vue&type=script&lang=ts&"
export * from "./batchCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports